import { render, staticRenderFns } from "./ExamPerformance.vue?vue&type=template&id=67269cfa"
import script from "./ExamPerformance.vue?vue&type=script&lang=js"
export * from "./ExamPerformance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports